export default __webpack_public_path__ + "static/media/Offers_Coupon_Icon.72b94c41.svg";